/**
 * Quem é o dono do teclado físico agora.
 *
 * Dois ouvintes disputam as mesmas teclas no computador: o `Teclado` da tela
 * (login, "Digitar") e o leitor USB, que também chega como teclado. Enquanto
 * houver um `Teclado` recebendo, o leitor fica de fora — com o "Digitar"
 * aberto, passar o ingresso no leitor digita o código no campo, como faria
 * qualquer teclado.
 */

let recebendo = 0;

export const tecladoFisico = {
  tomar(): void {
    recebendo++;
  },
  soltar(): void {
    recebendo = Math.max(0, recebendo - 1);
  },
  ocupadoPelaTela(): boolean {
    return recebendo > 0;
  },
};
